window.tasksModule.directive "noTasksMessage", ['$log', '$state', ($log, $state) ->
  restrict: "E"
  scope:
    text: '@'
  link: (scope, element, attrs) ->
    scope.$log = $log.getInstance('noTasksMessage directive', true, false, true)
    scope.$log.log 'noTasksMessage'

  templateUrl: 'portal/tasks/tasks/no-tasks-message/no-tasks-message-directive-template.html'
]